var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScheduledMessageStatus = function SvgScheduledMessageStatus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "#ECF1F3",
    rx: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A657B",
    id: "fr6ju9ep6a",
    d: "M9.76 10.04l11.59 5.403c.2.1.329.323.329.567 0 .242-.127.466-.328.567L9.76 21.96c-.055.02-.128.04-.202.04-.126 0-.272-.061-.363-.162-.164-.163-.218-.405-.146-.648l1.565-5.18-1.582-5.2c-.073-.223-.018-.487.146-.648.164-.162.381-.202.582-.121zm8.653 6.571h-6.835l-1.128 3.69 7.963-3.69zm-7.945-4.912l1.114 3.697h6.816l-7.93-3.697z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScheduledMessageStatus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scheduled-message-status.2f05615b3e54a66c50accb49b0c07ee3.svg";